import { api } from '@/lib/api';
import type {
  CreatePartSupplierPayload,
  PartSupplierLink,
  UpdatePartSupplierPayload,
} from './types';

export const partSuppliersApi = {
  list: async (partId: string): Promise<PartSupplierLink[]> => {
    const { data } = await api.get<PartSupplierLink[]>(
      `/parts/${partId}/suppliers`,
    );
    return data;
  },

  create: async (
    partId: string,
    input: CreatePartSupplierPayload,
  ): Promise<PartSupplierLink> => {
    const { data } = await api.post<PartSupplierLink>(
      `/parts/${partId}/suppliers`,
      input,
    );
    return data;
  },

  update: async (
    partId: string,
    partSupplierId: string,
    patch: UpdatePartSupplierPayload,
  ): Promise<PartSupplierLink> => {
    const { data } = await api.patch<PartSupplierLink>(
      `/parts/${partId}/suppliers/${partSupplierId}`,
      patch,
    );
    return data;
  },

  remove: async (partId: string, partSupplierId: string): Promise<void> => {
    await api.delete(`/parts/${partId}/suppliers/${partSupplierId}`);
  },
};
